export default {
    'SearchFormName': '搜索表单名称',
    'QueryTips1': '搜索结果：共',
    'QueryTips2': '条',
    'HistorySearch': '历史搜索',
    'PleaseInputKeys': '请输入搜索关键词',
    'RecentlyUsed': '最近使用',
    'WorkflowCount': '{length}个流程',
    'OpenFormsTips': '页面地址未设置，请联系管理员！',
};
